import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import CaseStudy from "@/pages/CaseStudy";
import Admin from "@/pages/Admin";
import RoleMap from "@/pages/RoleMap";
import Analytics from "@/pages/Analytics";
import CaseStudyPrint from "@/pages/CaseStudyPrint";
import PortfolioPdf from "@/pages/PortfolioPdf";
import CoverLetter from "@/pages/CoverLetter";
import AIConcierge from "@/components/site/AIConcierge";
import { PageViewTracker } from "@/components/site/Tracking";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";

function App() {
  return (
    <div className="App">
      <LangProvider>
      <BrowserRouter>
        <PageViewTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/case-studies/:slug" element={<CaseStudy />} />
          <Route path="/case-studies/:slug/print" element={<CaseStudyPrint />} />
          <Route path="/portfolio-pdf" element={<PortfolioPdf />} />
          <Route path="/cover-letter" element={<CoverLetter />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/admin/messages" element={<Admin />} />
          <Route path="/tools/role-map" element={<RoleMap />} />
        </Routes>
        <AIConcierge />
        <Toaster position="bottom-left" />
      </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
